import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavService } from './side-nav.service';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MatBadgeModule } from '@angular/material/badge';
import { TranslocoModule } from '@jsverse/transloco';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  declarations: [SideNavComponent],
  exports: [SideNavComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatListModule,
    MatBadgeModule,
    AppRoutingModule,
    TranslocoModule,
    MatRippleModule,
  ],
  providers: [SideNavService],
})
export class SideNavModule {}
